import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AuthenticationService,
  EnvConfigurationService
} from '@services/index';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private configService: EnvConfigurationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserValue;
    const currentTenant = this.authenticationService.currentTenantValue;

    const isLoggedIn =
      currentUser &&
      currentUser.jwtToken &&
      currentTenant &&
      currentTenant.id === currentUser.tenantId;

    const isApiUrl =
      request.url.startsWith(this.configService.config?.lmsApiUrl) ||
      request.url.startsWith('/api/v');
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          Authorization: `Bearer ${currentUser.jwtToken}`,
        },
      });
    }

    return next.handle(request);
  }
}
